export default __webpack_public_path__ + "static/media/folio.599dc3bc.png";